// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#2380c3"};